import { Component } from '@angular/core';
import { LacertaDynamicPageWithMetaComponent, LacertaDynamicWagtailPage } from '@lacerta/cms';

@Component({
  template: ` <riff-home [page]="this.context"></riff-home> `,
})
export class RiffWagtailHomeComponent extends LacertaDynamicPageWithMetaComponent<LacertaDynamicWagtailPage> {}
